import { useTranslation } from 'react-i18next';
import i18n from '../../i18n/config';
// Tarjeta visual limpia del ticket para captura/compartir. Sin navbar/sidebar ni datos privados.
import React, { forwardRef } from 'react';
import { Box, Typography, Chip, Divider } from '@mui/material';

const Row = ({ label, value }) => (
  <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, py: 0.6, borderBottom: '1px solid #eee' }}>
    <Typography variant="caption" sx={{ color: '#6b6b6b' }}>{label}</Typography>
    <Typography variant="body2" sx={{ fontWeight: 600, textAlign: 'right' }}>{value ?? '—'}</Typography>
  </Box>
);

const TicketShareCard = forwardRef(function TicketShareCard({ summary }, ref) {
  const { t } = useTranslation();
  const s = summary || {};
  return (
    <Box ref={ref} sx={{ width: 420, bgcolor: '#fff', fontFamily: '-apple-system,Segoe UI,Roboto,Arial,sans-serif' }}>
      <Box sx={{ height: 6, background: 'linear-gradient(90deg,#d32f2f,#b71c1c)' }} />
      <Box sx={{ p: 2.5 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
          <Typography sx={{ fontSize: 13, fontWeight: 800, letterSpacing: '.14em', color: '#d32f2f', textTransform: 'uppercase' }}>{i18n.t('hardcoded.pages_adoptioncampaignspage.arsenal_aps')}</Typography>
          <Chip label={s.ticket_number} size="small" sx={{ fontWeight: 800, bgcolor: '#1a1a1a', color: '#fff' }} />
        </Box>
        <Box sx={{ display: 'flex', gap: 1, mb: 1.5 }}>
          <Chip label={s.severity_label} size="small" sx={{ bgcolor: s.severity_color || '#d32f2f', color: '#fff', fontWeight: 700 }} />
          <Chip label={s.status === 'resolved' ? t('alarmTickets.status.resolved') : s.status === 'acknowledged' ? t('alarmTickets.status.acknowledged') : t('alarmTickets.status.open')} size="small" variant="outlined" />
          <Chip label={s.incidence} size="small" variant="outlined" />
        </Box>
        <Row label={t('vehicles.table.vehicle')} value={s.vehicle_name} />
        <Row label={t('hardcoded.components_alarms_alarmlist.metrica')} value={s.metric_label} />
        <Row label={t('alarms.list.position')} value={s.position_line} />
        <Row label={t('hardcoded.components_alarms_alarmlist.valor_actual')} value={s.value_display} />
        <Row label={t('hardcoded.pages_alarmticketdetailpage.rango_permitido')} value={s.range_display} />
        {s.profile_name && <Row label={t('hardcoded.components_tickets_ticketsharecard.perfil_de_alertas')} value={s.profile_name} />}
        <Box sx={{ mt: 1.5, p: 1.5, bgcolor: '#fdf4f4', border: '1px solid #f3d6d6', borderRadius: 1 }}>
          <Typography sx={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', color: '#b71c1c', letterSpacing: '.06em' }}>{i18n.t('hardcoded.pages_tpmsactionsummarypage.que_hay_que_hacer')}</Typography>
          <Typography variant="body2" sx={{ mt: 0.5 }}>{s.recommended_action}</Typography>
        </Box>
        <Divider sx={{ my: 1.5 }} />
        <Typography variant="caption" sx={{ color: '#9e9e9e' }}>
          {i18n.t('hardcoded.components_tickets_ticketsharecard.generado')}{new Date().toLocaleString('es-MX')} {i18n.t('hardcoded.components_tickets_ticketsharecard.apsarsenalmx')}</Typography>
      </Box>
    </Box>
  );
});

export default TicketShareCard;
